import React from 'react';

import { RouteObject } from 'react-router-dom';

const ResourceBatches = React.lazy(
  () => import('@/pages/Resources/views/ResourceBatches'),
);
const PurchaseHistory = React.lazy(
  () => import('@/pages/Resources/views/PurchaseHistory'),
);

export const resourcesDetailPath = {
  ResourceBatches: '',
  PurchaseHistory: 'purchase-history',
};

export const resourcesDetailRoutes: RouteObject[] = [
  { index: true, element: <ResourceBatches /> },
  {
    path: resourcesDetailPath.PurchaseHistory,
    element: <PurchaseHistory />,
  },
];
